(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blendit-shop-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('blendit-category-videos')) return;

  customElements.define('blendit-category-videos', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initializeVideos());
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      if (this.disposeVideos) this.disposeVideos();
      this.disposeVideos = null;
    }

    initializeVideos() {
      if (this.disposeVideos || !this.isConnected) return;
      const controller = new AbortController();
      const events = { signal: controller.signal };
      const canHover = matchMedia('(hover: hover) and (pointer: fine)');
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const players = [];
      const stopAll = (except) => {
        players.forEach((player) => { if (player !== except) player.stop(); });
      };
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                const player = players.find((item) => item.card === entry.target);
                if (player) player.stop();
              }
            });
          })
        : null;

      this.querySelectorAll('.blendit-category-card').forEach((card) => {
        const video = card.querySelector('video[data-video-src]');
        const button = card.querySelector('.blendit-category-card__video-toggle');
        if (!video || !button) return;
        const name = button.dataset.videoTitle || 'category';
        let requested = false;
        let requestId = 0;
        let player;

        const setButton = (active) => {
          card.classList.toggle('is-video-active', active);
          button.setAttribute('aria-label', `${active ? 'Pause' : 'Play'} ${name} video`);
          button.title = active ? 'Pause video' : 'Play video';
        };
        const stop = () => {
          requested = false;
          requestId += 1;
          card.classList.remove('is-playing');
          setButton(false);
          button.removeAttribute('aria-busy');
          video.pause();
          if (video.hasAttribute('src')) {
            try { video.currentTime = 0; } catch (_) { /* Metadata is not ready yet. */ }
          }
        };
        const start = () => {
          if (requested) return;
          stopAll(player);
          requested = true;
          const currentRequest = ++requestId;
          setButton(true);
          button.setAttribute('aria-busy', 'true');
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          // The source is attached only after a hover or an explicit play action.
          if (!video.hasAttribute('src')) video.src = video.dataset.videoSrc;
          try {
            const attempt = video.play();
            if (attempt && typeof attempt.catch === 'function') {
              attempt.catch(() => {
                // A previous hover must not cancel a newer playback request.
                if (currentRequest === requestId) stop();
              });
            }
          } catch (_) { stop(); }
        };

        player = { card, button, stop };
        players.push(player);
        button.hidden = false;

        card.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && canHover.matches &&
              !reduceMotion.matches && !(navigator.connection && navigator.connection.saveData)) {
            start();
          }
        }, events);
        card.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') stop();
        }, events);
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (requested) stop(); else start();
        }, events);
        card.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') stop();
        }, events);
        card.addEventListener('focusout', (event) => {
          if (!card.contains(event.relatedTarget)) stop();
        }, events);
        card.querySelector('.blendit-category-card__link').addEventListener('click', stop, events);
        video.addEventListener('playing', () => {
          if (!requested) { video.pause(); return; }
          card.classList.add('is-playing');
          button.removeAttribute('aria-busy');
        }, events);
        video.addEventListener('pause', () => {
          if (video.paused && requested) stop();
        }, events);
        video.addEventListener('error', stop, events);
        if (observer) observer.observe(card);
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAll();
      }, events);
      window.addEventListener('pagehide', () => stopAll(), events);
      canHover.addEventListener('change', () => stopAll(), events);
      reduceMotion.addEventListener('change', () => stopAll(), events);
      this.disposeVideos = () => {
        controller.abort();
        if (observer) observer.disconnect();
        stopAll();
        players.forEach((player) => { player.button.hidden = true; });
      };
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }

      const customSearch = this.header.querySelector('.header__search-custom');
      if (customSearch) {
        customSearch.removeAttribute('open');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
